import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from "components/ui/dialog";

export type AlertType = "alert" | "confirm";

const AlertDialogPage = ({
  open,
  hide,
  title,
  message,
  type = "alert",
  onOK,
  onClose,
}: {
  open: boolean;
  hide: () => void;
  title: string;
  message: string;
  type?: AlertType;
  onOK?: () => void;
  onClose?: () => void;
}) => {
  return (
    <Dialog open={open} modal={true}>
      <DialogOverlay className="z-[100]" />
      <DialogContent className="z-[101]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="whitespace-break-spaces w-full max-w-[450px]">
            {message}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row justify-center items-center gap-4">
          {type === "alert" ? (
            <Button
              variant="primary"
              onClick={(e) => {
                hide();
                if (onOK) {
                  onOK();
                }
              }}
            >
              확인
            </Button>
          ) : (
            <>
              <Button
                onClick={(e) => {
                  hide();
                  if (onClose) {
                    onClose();
                  }
                }}
              >
                취소
              </Button>
              <Button
                variant="primary"
                onClick={(e) => {
                  hide();
                  if (onOK) {
                    onOK();
                  }
                }}
              >
                확인
              </Button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AlertDialogPage;
